import React, { useState } from 'react';
import { useRecordContext } from 'react-admin';
import {
  IconButton, Tooltip, Typography, Stack,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { get } from 'lodash-es';

export function CopyField({
  source, value: valueProp, children, ...props
}) {
  const record = useRecordContext(props);
  const [isCopied, setIsCopied] = useState(false);
  const value = valueProp || get(record, source);

  if (!value) {
    return '-';
  }

  const handleCopy = (event) => {
    event.preventDefault();
    event.stopPropagation();
    navigator.clipboard.writeText(value).then(
      () => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      },
      () => {
        // Silently fail - could add error handling here if needed
      },
    );
  };

  return (
    <Stack direction="row" alignItems="center" spacing={0.5} {...props}>
      {
        children || (
          <Typography variant="caption" component="span">{value.toString()}</Typography>
        )
      }
      <Tooltip title={isCopied ? 'Copied!' : 'Copy'}>
        <IconButton
          onClick={handleCopy}
          aria-label={isCopied ? 'Copied' : 'Copy'}
          size="small"
        >
          {isCopied ? (
            <CheckIcon sx={{ fontSize: 14, color: 'success.main' }} />
          ) : (
            <ContentCopyIcon sx={{ fontSize: 14 }} />
          )}
        </IconButton>
      </Tooltip>
    </Stack>
  );
}

CopyField.defaultProps = {
  label: 'Value',
};
